<template>
  <div class="template-logo-wrap">
    <svg class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32"><path d="M102.4 102.4m51.2 0l279.9104 0q51.2 0 51.2 51.2l0 279.9104q0 51.2-51.2 51.2l-279.9104 0q-51.2 0-51.2-51.2l0-279.9104q0-51.2 51.2-51.2Z" fill="#1890FF" p-id="22419"></path><path d="M102.4 539.2896m51.2 0l279.9104 0q51.2 0 51.2 51.2l0 279.9104q0 51.2-51.2 51.2l-279.9104 0q-51.2 0-51.2-51.2l0-279.9104q0-51.2 51.2-51.2Z" fill="#1890FF" p-id="22420"></path><path d="M539.2896 102.4m51.2 0l279.9104 0q51.2 0 51.2 51.2l0 279.9104q0 51.2-51.2 51.2l-279.9104 0q-51.2 0-51.2-51.2l0-279.9104q0-51.2 51.2-51.2Z" fill="#1890FF" opacity=".3" p-id="22421"></path><path d="M539.2896 539.2896m51.2 0l279.9104 0q51.2 0 51.2 51.2l0 279.9104q0 51.2-51.2 51.2l-279.9104 0q-51.2 0-51.2-51.2l0-279.9104q0-51.2 51.2-51.2Z" fill="#1890FF" opacity=".3" p-id="22422"></path></svg>
    <span>{{ system.toUpperCase() }}</span>
    <span>WEB</span>
  </div>
</template>

<script>
  import { system, title } from '@/config'
  export default {
    name: 'Logo',
    data () {
      return {
        system: system || title
      }
    }
  }
</script>

<style lang="scss">
  .template-logo-wrap {
    display: flex;
    align-items: center;
    font-size: 31px;
    font-weight: lighter;
    font-family: "Microsoft YaHei UI Light";
    span {
      color: #1890FF;
      opacity: 0.9;
      margin-left: 5px;
    }
    span:last-child {
      opacity: 0.5;
    }
  }
</style>
